<template>
    <div id="PlanSelectionCompleted" class="d-flex flex-row justify-content-center">
        <a-card class="completed-card">
            <div class="card-header-part">
                <div class="card-header-part-header"></div>
                <div class="blured-background-icon">
                    <SupsisIcon class="styled-supsis-icon" width="180" height="200" />
                </div>
                <div class="triangle"></div>
                <div class="centered-icon">
                    <SupsisIcon width="90" height="90" />
                </div>
            </div>
            <div style="height: 260px" class="card-information-part">
                <div class="mx-2 my-0">
                    <h2 class="my-0 px-5">Bilgileriniz başarıyla kaydedildi</h2>
                    <p class="description">
                        Sayın kullanıcı , yeni özellikleriniz aktif edildi. SUPSIS ayrıcalıklarını kullanmaya
                        başlayabilirsiniz.
                    </p>
                </div>
                <a-button class="w-75 start-use-btn py-4" @click="buttonClickHandler"> Kullanmaya Başla</a-button>
            </div>
        </a-card>
    </div>
</template>

<script>
import SupsisIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/SupsisIcon.vue";

export default {
    name: "PlanSelectionCompleted",
    components: { SupsisIcon },
    methods: {
        buttonClickHandler() {
            this.$emit("clickHandler");
        },
    },
};
</script>

<style lang="scss">
#PlanSelectionCompleted {
    .ant-card-body {
        padding: unset;
    }

    .completed-card {
        width: 600px;
        height: 500px;
        border-radius: 31px;
    }

    .styled-supsis-icon {
        path {
            fill: white !important;
            opacity: 0.2 !important;
        }
    }

    .card-header-part {
        height: 250px;
    }

    .blured-background-icon {
        height: 0;
        position: relative;
        top: -150px;
        right: -420px;
    }

    .centered-icon {
        border-radius: 50%;
        height: 130px;
        width: 130px;
        background: #ffffff;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        text-align: center;
        position: relative;
        top: -115px;
        right: -250px;
        -webkit-box-shadow: 3px 3px 5px 2px rgb(0 0 0 / 25%);
        box-shadow: 3px 3px 5px 2px rgb(0 0 0 / 25%);
    }

    .card-information-part {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        align-items: center;
    }

    .card-header-part-header {
        height: 100px;
        background-color: rgb(236 75 29) !important;
        border: 1px rgb(236 75 29) solid !important;
        border-radius: 30px 30px 0 0;
    }

    p.description {
        word-break: break-word;
        white-space: break-spaces;
    }

    .triangle {
        border-right: 598px solid rgb(236 75 29);
        border-bottom: 100px solid transparent;
    }

    .start-use-btn {
        border: 1px rgb(236 75 29) solid !important;
        background-color: rgb(236 75 29) !important;
        color: white !important;
        -webkit-border-radius: 12px;
        -moz-border-radius: 12px;
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        align-items: center;
        font-weight: 600;
    }
}
</style>
